import axiosIns from '@/plugins/axios'
import { AggregationResultAttributes } from '@/api/v2/types/aggregation-result'
import { AggregationSingleResponse } from '@/api/v2/report/Aggregation'

export async function fetchAggregation(
  id: number,
  params: {
    start_date: string
    end_date: string
  },
): Promise<AggregationResultAttributes> {
  const res = await axiosIns.get<AggregationSingleResponse>(
    `/v2/data_export/aggregations/${id}`,
    { params },
  )

  return res.data.data.data.attributes
}

export async function enqueueAggregation(
  id: number,
  params: {
    start_date: string
    end_date: string
  },
): Promise<{ status: string }> {
  const res = await axiosIns.get(
    `/v2/data_export/aggregations/${id}/enqueue`,
    { params },
  )

  return res.data
}

export async function getAggregationStatus(
  id: number,
  params: {
    start_date: string
    end_date: string
  },
): Promise<{
  status: string
  result?: AggregationResultAttributes
  errorMessage?: string
  meta: {
    createdAt: string
    updatedAt: string
  }
}> {
  const res = await axiosIns.get<{
    status: string
    data: {
      status: string
      result: AggregationSingleResponse['data'] | null,
      errorMessage?: string
      meta: {
        createdAt: string
        updatedAt: string
      }
    }
  }>(
    `/v2/data_export/aggregations/${id}/status`,
    { params },
  )

  const {
    status, result, errorMessage, meta,
  } = res.data.data

  return {
    status,
    result: result?.data?.attributes,
    errorMessage,
    meta,
  }
}
